<script>
  import fetchWrapper from '@/lib/fetchWrapper.js';
  import { emitter } from '@/main.js';
  import { whenFastSimonReady } from '@/lib/vue-helpers.js';

  export default {
    name: 'PDPaddToCartButton',
    data() {
      return {
        localLoading: this.loading,
        localSuccess: this.success,
        localError: this.error,
        localEmailFormValidationError: this.emailFormValidationError,
        localShowWidget: this.showWidget,
        membershipInCart: window._authentic_membershipInCart || false,
        memberIsSubscribed: false,
        memberDiscountApplied: false,
        isMobile: window.innerWidth < window.theme?.sizes.medium
      };
    },
    props: {
      instock: {
        type: Boolean,
        required: true
      },
      comingSoonProduct: {
        type: Boolean,
        required: true
      },
      success: {
        type: Boolean,
        required: true
      },
      addToCartText: {
        type: String,
        required: true
      },
      comingsoonText: {
        type: String,
        required: true
      },
      variantPrice: {
        type: String,
        required: true
      },
      soldOutText: {
        type: String,
        required: true
      },
      showingForm: {
        type: Boolean,
        required: true
      },
      unavailableText: {
        type: String,
        required: true
      },
      notifyMeText: {
        type: String,
        required: true
      },
      notavail: {
        type: Boolean,
        required: true
      },
      isSticky: {
        type: Boolean,
        default: false,
        required: false
      },
      variantId: {
        type: String,
        required: true
      },
      formEmail: {
        type: String,
        required: false
      },
      formEmailList: {
        type: String,
        required: false
      },
      formEmailListId: {
        type: String,
        required: false
      },
      klaviyo_key: {
        type: String,
        required: false
      },
      klaviyoFormShowing: {
        type: Boolean,
        required: true
      },
      emailFormValidationError: {
        type: Boolean,
        required: true
      },
      scrollToVariantData: {
        type: Function,
        required: false
      },
      membershipPrice: {
        type: String,
        required: false
      },
      useMemberPrice: {
        type: Boolean,
        required: false,
        default: false
      },
      isOutfitPicker: {
        type: Boolean,
        required: false,
        default: false
      },
      surface: {
        type: String,
        required: false,
        default: 'pdp'
      }
    },
    methods: {
      checkClass() {
        if (this.localLoading) {
          return 'gt-btn__atc btn--outline btn--full btn--primary btn--add-to-cart loading';
        } else {
          return `gt-btn__atc btn--outline btn--full btn--primary btn--add-to-cart form-${this.showingForm} stock-${this.instock} coming-soon-${this.comingSoonProduct} klaviyo-form-showing-${this.klaviyoFormShowing}`;
        }
      },
      stripHtml(html) {
        if (html == null || html === '') return '';
        const tmp = document.createElement('span');
        tmp.innerHTML = html;
        return (tmp.textContent || '').replace(/\s+/g, ' ').trim();
      },
      validateEmail(email) {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
      },
      checkSoldOutMessage() {
        if (this.notavail) {
          return this.unavailableText;
        }
        if (!this.instock && this.klaviyoFormShowing) {
          return this.notifyMeText;
        }
        return this.soldOutText;
      },
      handleAddToCartClick() {
        if (this.localLoading) {
          return;
        }
        if (!this.showingForm && this.variantId && !this.notavail && this.instock && !this.comingSoonProduct) {
          this.addToBag();
        }

        if (this.showingForm && this.variantId) {
          if (this.isSticky) {
            this.scrollToVariantData();
          } else {
            if (!this.validateEmail(this.formEmail)) {
              this.localEmailFormValidationError = true;
            } else {
              this.localEmailFormValidationError = false;
              this.submitKlaviyo();
            }

            emitter.emit('updateEmailError', {
              emailFormValidationError: this.localEmailFormValidationError
            });
          }
        }
      },
      reloadCart() {
        const cartRequest = window.theme && window.theme.getCart ? window.theme.getCart(true) : fetchWrapper.get(`${window.theme.routes.cart}.js`).then(response => response.json());
        cartRequest
          .then(cart => {
            document.dispatchEvent(
              new CustomEvent('theme:cart:change', {
                detail: {
                  cart
                },
                bubbles: true
              })
            );
            document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
            setTimeout(() => {
              [...document.querySelectorAll("[ data-drawer-toggle='drawer-cart']")].forEach(el => {
                el.click();
              });
              this.localLoading = false;
              emitter.emit('cart-added', { surface: this.surface });
            }, 300);
          })
          .catch(e => {
            console.error('PDPaddToCartButton: Error loading widget:', {
              error: e?.message || e,
              stack: e?.stack,
              response: e?.response,
              fullError: e
            });
            this.localShowWidget = false;
            this.localError = true;
            this.localLoading = false;
          });
      },
      addToBag() {
        if (!this.variantId) {
          console.error('Add to cart failed: No variant ID');
          return;
        }
        const variantIdNum = parseInt(this.variantId, 10);
        if (isNaN(variantIdNum) || variantIdNum <= 0) {
          console.error('Add to cart failed: Invalid variant ID', this.variantId);
          return;
        }
        localStorage.setItem('clear-tracking', true);
        this.localLoading = true;
        const formData = {
          items: [
            {
              id: variantIdNum,
              quantity: 1
            }
          ]
        };
        if (this.gwpEnabled) {
          if (this.parentId === this.gwpProduct1 || this.parentId === this.gwpProduct2 || this.parentId === this.gwpProduct3 || this.parentId === this.gwpProduct4 || this.parentId === this.gwpProduct5) {
            formData.properties = {};
            formData.properties[this.gwpTag] = true;
          }
        }

        const successfulCartUpdate = response => {
          response.self.reloadCart();
        };

        const errorCartUpdate = (error, self) => {
          self.localLoading = false;
          console.error('Failed to add item to cart:', error.message || error);
        };

        fetchWrapper.postCart(formData, this, successfulCartUpdate, errorCartUpdate);
        // eslint-disable-next-line

        this.reportCartPageVisited();
        this.reportAddToCartPerformed();
      },
      reportCartPageVisited() {
        whenFastSimonReady(() => {
          // FS: Cart Page Visited
          // https://docs.fastsimon.com/sdk/docs/events/cart
          window.FastSimonSDK.event({
            reportAppType: 'MPA',
            eventName: window.FastSimonEventName.CartVisited,
            data: {} // (Required)
          });
        });
      },
      reportAddToCartPerformed() {
        whenFastSimonReady(() => {
          // FS: Product Added to cart
          // https://docs.fastsimon.com/sdk/docs/events/cart#product-added-to-cart
          window.FastSimonSDK.event({
            reportAppType: 'MPA',
            eventName: window.FastSimonEventName.AddToCartPerformed,
            data: {
              productID: this.variantId // (Required)
            }
          });
        });
      },
      submitKlaviyo() {
        const email = this.formEmail;
        if (!this.validateEmail(email)) {
          this.localEmailFormValidationError = true;
          emitter.emit('updateEmailError', {
            emailFormValidationError: this.localEmailFormValidationError
          });
          return;
        }

        this.localLoading = true;

        this.subscribeToBackInStock(email)
          .then(() => {
            this.localSuccess = true;

            // Only attempt to subscribe to marketing list if checkbox is checked
            // and we have the list ID
            if (this.formEmailList && this.formEmailListId) {
              return this.subscribeToMarketingList(email);
            }
            return Promise.resolve();
          })
          .then(() => {
            this.localLoading = false;
            emitter.emit('updateSuccessState', {
              success: this.localSuccess
            });
          })
          .catch(err => {
            console.error('Klaviyo subscription error:', err);
            this.localLoading = false;
            this.localError = true;
            emitter.emit('updateSuccessState', {
              error: this.localError
            });
          });
      },
      async subscribeToBackInStock(email) {
        const options = {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2025-04-15',
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email
                    }
                  }
                }
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: '$shopify:::$default:::' + this.variantId
                  }
                }
              }
            }
          })
        };

        try {
          const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + this.klaviyo_key, options);
          if (!response.ok) {
            const text = await response.text();
            console.error('Error:', response.status, text);
            throw new Error('Failed to subscribe to back in stock');
          }
          return response;
        } catch (error) {
          console.error('Klaviyo back-in-stock subscription error:', error);
          throw error;
        }
      },
      async subscribeToMarketingList(email) {
        const options = {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2025-04-15',
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: 'SUBSCRIBED'
                          }
                        }
                      }
                    }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: this.formEmailListId
                  }
                }
              }
            }
          })
        };

        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + this.klaviyo_key, options);
          if (!response.ok) {
            const text = await response.text();
            console.error('Error:', response.status, text);
            throw new Error('Failed to subscribe to marketing list');
          }
          return response;
        } catch (error) {
          console.error('Klaviyo marketing list subscription error:', error);
          throw error;
        }
      },
      isUSD() {
        return window.Shopify.currency.active === 'USD';
      },
      async getAppliedDiscounts() {
        let hasAuthenticDiscount = false;
        try {
          const cartData = window.theme && window.theme.getCart ? await window.theme.getCart() : await (await fetch('/cart.js')).json();
          hasAuthenticDiscount = cartData.cart_level_discount_applications.some(disc => disc.title === 'AUTHENTIC');
          emitter.emit('membershipDiscountApplied', {
            isApplied: hasAuthenticDiscount
          });
        } catch (error) {
          console.error('Error fetching cart:', error);
        }

        return hasAuthenticDiscount;
      }
    },
    computed: {
      displayPrice() {
        return (this.membershipInCart || this.memberIsSubscribed || this.memberDiscountApplied) && this.isUSD() && this.membershipPrice && this.useMemberPrice ? this.membershipPrice : this.variantPrice;
      },
      accessibleName() {
        if (this.comingSoonProduct) return this.stripHtml(this.comingsoonText);
        if (!this.instock) return this.stripHtml(this.checkSoldOutMessage());
        const label = this.stripHtml(this.addToCartText);
        const showPrice = !this.isOutfitPicker || !this.isMobile;
        if (!showPrice) return label;
        const price = this.stripHtml(this.displayPrice);
        return price ? `${label} ${price}` : label;
      }
    },
    async mounted() {
      const originalDescriptor = Object.getOwnPropertyDescriptor(window, '_authentic_membershipInCart');
      Object.defineProperty(window, '_authentic_membershipInCart', {
        get: function () {
          return originalDescriptor ? (originalDescriptor.get ? originalDescriptor.get.call(window) : originalDescriptor.value) : false;
        },
        set: value => {
          if (originalDescriptor && originalDescriptor.set) {
            originalDescriptor.set.call(window, value);
          }
          this.membershipInCart = value || false;
        },
        configurable: true
      });

      emitter.on('membershipStatusUpdated', e => {
        this.memberIsSubscribed = e.isSubscribed;
      });

      this.memberDiscountApplied = await this.getAppliedDiscounts();

      if (this.isOutfitPicker) {
        this.onResize = () => {
          this.isMobile = window.innerWidth < window.theme?.sizes.medium;
        };
        document.addEventListener('theme:resize:width', this.onResize);
      }
    },
    beforeUnmount() {
      const originalDescriptor = Object.getOwnPropertyDescriptor(window, '_authentic_membershipInCart');
      if (originalDescriptor) {
        Object.defineProperty(window, '_authentic_membershipInCart', originalDescriptor);
      }
      if (this.isOutfitPicker) {
        document.removeEventListener('theme:resize:width', this.onResize);
        this.onResize = null;
      }
    }
  };
</script>

<template>
  <button type="submit" name="add" :class="checkClass()" data-add-to-cart="" :aria-busy="localLoading ? true : undefined" :aria-label="accessibleName" v-show="!success" @click="handleAddToCartClick()" :ref="!isSticky ? 'atcBtn' : 'stickyATCBtn'">
    <span class="gt-btn__atc btn-state-ready gt-btn__atc" v-if="instock && !comingSoonProduct">
      <span data-add-to-cart-text="" v-html="addToCartText"></span>
      <span v-if="!isOutfitPicker || (isOutfitPicker && !isMobile)" class="cta__dot">&bull;</span>
      <span v-if="!isOutfitPicker || (isOutfitPicker && !isMobile)" data-button-price="" v-html="displayPrice"></span>
    </span>

    <span class="gt-btn__atc btn-state-ready" v-if="comingSoonProduct">
      <span data-add-to-cart-text="" v-html="comingsoonText"></span>
    </span>

    <span class="gt-btn__atc btn-state-ready" v-if="!instock && !comingSoonProduct">
      <span data-add-to-cart-text="" v-html="checkSoldOutMessage()"></span>
    </span>

    <span class="gt-btn__atc btn-state-loading" aria-hidden="true">
      <svg height="18" width="18" class="svg-loader">
        <circle r="7" cx="9" cy="9"></circle>
        <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle>
      </svg>
    </span>

    <span class="gt-btn__atc btn-state-complete" aria-hidden="true">&nbsp;</span>
  </button>
</template>
